/**
 * Currently, we only support element tracking with `scrollInfo`, though in
 * the future we can also offer ViewTimeline support.
 */
function isElementTracking(options) {
    return options && (options.target || options.offset);
}

export { isElementTracking };
//# sourceMappingURL=is-element-tracking.mjs.map
